export function bindStripeIframeReady(params: {
  container: HTMLElement;
  onIframeReady: () => void;
  hasReportedRef: { current: boolean };
}): () => void {
  const { container, onIframeReady, hasReportedRef } = params;

  hasReportedRef.current = false;

  let iframeCleanup: (() => void) | null = null;

  const markIframeReady = () => {
    if (hasReportedRef.current) {
      return;
    }
    hasReportedRef.current = true;
    onIframeReady();
  };

  const bindIframe = (iframe: HTMLIFrameElement) => {
    const handleLoad = () => {
      iframe.removeEventListener('load', handleLoad);
      markIframeReady();
    };

    iframe.addEventListener('load', handleLoad, { once: true });
    iframeCleanup = () => {
      iframe.removeEventListener('load', handleLoad);
    };
  };

  const existingIframe = container.querySelector('iframe');
  if (existingIframe) {
    bindIframe(existingIframe);
    return () => {
      iframeCleanup?.();
    };
  }

  const observer = new MutationObserver(() => {
    if (hasReportedRef.current || iframeCleanup) {
      return;
    }

    const iframe = container.querySelector('iframe');
    if (iframe) {
      observer.disconnect();
      bindIframe(iframe);
    }
  });

  observer.observe(container, {
    childList: true,
    subtree: true,
  });

  return () => {
    observer.disconnect();
    iframeCleanup?.();
  };
}
